/*
 * DISTRIBUTION STATEMENT C. Distribution authorized to U.S. Government Agencies and their contractors; Critical
 * Technology; 19 October 2017. Other requests for this document shall be referred to Chemical and Biological
 * Technologies, Defense Threat Reduction Agency, 8725 John J Kingman Road, Fort Belvoir, VA 22060-6201.
 *
 * WARNING: This document contains technical data whose export is restricted by the Arms Export Control Act (Sec 2751
 * of Title 22, United States Code) or the Export Control Reform Act of 2018 (Chapter 58 Sections 4801-4852 of Title
 * 50, United States Code). Violations of these export laws are subject to severe criminal penalties. Disseminate in
 * accordance with provisions of DoD Directive 5230.25 and DoD Instruction 2040.02. DESTRUCTION NOTICE: For
 * unclassified, limited distribution documents, destroy by any method that will prevent disclosure of the contents
 * or reconstruction of the document.
 *
 * This material is based upon work supported by the Under Secretary of War for Research and Engineering under Air
 * Force Contract No. FA8702-15-D-0001 or FA8702-25-D-B002. Any opinions, findings, conclusions or recommendations
 * expressed in this material are those of the author(s) and do not necessarily reflect the views of the Under
 * Secretary of War for Research and Engineering.
 *
 * © 2026 Massachusetts Institute of Technology.
 *
 * The software/firmware is provided to you on an As-Is basis
 *
 * Delivered to the U.S. Government with Unlimited Rights, as defined in DFARS Part 252.227-7013 or 7014 (Feb 2014).
 * Notwithstanding any copyright notice, U.S. Government rights in this work are defined by DFARS 252.227-7013 or
 * DFARS 252.227-7014 as detailed above. Use of this work other than as specifically authorized by the U.S.
 * Government may violate any copyrights that exist in this work.
 *
 * This document contains Controlled Unclassified Information (CUI). Handling of this information is subject to the
 * controls identified in DFARS 252.204-7012 - SAFEGUARDING COVERED DEFENSE INFORMATION AND CYBER INCIDENT REPORTING.
 */

import {connect} from "react-redux";
import {Fragment, lazy, Suspense} from "react";
import {ProvideTheme} from "rapids-gui-library";
import {BrowserRouter as Router, Navigate, Route, Routes} from "react-router-dom";
import ScrollToTop from "../components/ScrollToTop";
import GlobalLoader from "../components/GlobalLoader";
import ChallengeFooter from "../components/ChallengeFooter";
import ChallengeHeader from "../components/ChallengeHeader";

// App Pages
const ChallengePage = lazy(() => import('../pages/ChallengePage.js'));
const HelpPage = lazy(() => import('../pages/GuidePage.js'));
const DocumentsPage = lazy(() => import('../pages/DocumentsPage.js'));
const EthicsPledgePage = lazy(() => import('../pages/EthicsPledgePage.js'));
const UserProfilePage = lazy(() => import('../pages/UserProfilePage.js'));
const LoginPage = lazy(() => import('../pages/LoginPage.js'));
const AdminPage = lazy(()=> import('../pages/AdminPage.js'));

const StudiesListPage = lazy(() => import('../pages/StudiesListPage.js'));
const StudyCardPage = lazy(() => import('../pages/StudyCardPage.js'));
const StudyRegisterPage = lazy(() => import('../pages/StudyRegisterPage.js'));

const AlgorithmsListPage = lazy(() => import('../pages/AlgorithmsListPage.js'));
const ModelPage = lazy(() => import('../pages/ModelPage.js'));
const AlgorithmRegisterPage = lazy(() => import('../pages/AlgorithmRegisterPage.js'));

const ToolListPage = lazy(() => import('../pages/ToolListPage.js'));
const ToolPage = lazy(() => import('../pages/ToolPage.js'));
const ToolRegisterPage = lazy(() => import('../pages/ToolRegisterPage.js'));

const PipelineStudioPage = lazy(() => import('../pages/PipelineStudioPage.js'));


function Challenge({userInfo, pageInfo, logged_in, ...props}) {
    return (
        <ProvideTheme>
            <div className='App-background'>
                <Router>
                    <ScrollToTop/>
                    <GlobalLoader/>
                    <ChallengeHeader/>
                    <Routes>
                        <Route path='home' element={<Suspense fallback={<>...</>}><ChallengePage/></Suspense>}/>
                        <Route path='guide' element={<Suspense fallback={<>...</>}><HelpPage/></Suspense>}/>
                        <Route path='ethicspledge'
                               element={<Suspense fallback={<>...</>}><EthicsPledgePage/></Suspense>}/>
                        <Route path='userprofile'
                               element={<Suspense fallback={<>...</>}><UserProfilePage/></Suspense>}/>
                                {/*<Route path='user'*/}
                                {/*       element={<Suspense fallback={<>...</>}><UserProfilePage/></Suspense>}>*/}
                                {/*    <Route path=':userid'*/}
                                {/*           element={<Suspense fallback={<>...</>}><UserProfilePage/></Suspense>}/>*/}
                                {/*</Route>*/}

                        <Route path='studies' element={<Suspense fallback={<>...</>}><StudiesListPage /></Suspense>} />
                        <Route path='registerstudy'
                               element={<Suspense fallback={<>...</>}><StudyRegisterPage/></Suspense>}/>
                        <Route path='editstudy/:key'
                               element={<Suspense fallback={<>...</>}><StudyRegisterPage/></Suspense>}/>
                        <Route path='study' element={<Suspense fallback={<>...</>}><StudyCardPage/></Suspense>}>
                            <Route path=':key'
                                   element={<Suspense fallback={<>...</>}><StudyCardPage/></Suspense>}/>
                        </Route>

                        {(pageInfo?.feature_analyst_workbench) && <>
                            <Route path='algorithms'
                                   element={<Suspense fallback={<>...</>}><AlgorithmsListPage/></Suspense>}/>
                            <Route path='registeralgorithm'
                                   element={<Suspense fallback={<>...</>}><AlgorithmRegisterPage/></Suspense>}/>
                            <Route path='editalgorithm/:key'
                                   element={<Suspense fallback={<>...</>}><AlgorithmRegisterPage/></Suspense>}/>
                            <Route path='algorithm'
                                   element={<Suspense fallback={<>...</>}><ModelPage/></Suspense>}>
                                <Route path=':key'
                                       element={<Suspense fallback={<>...</>}><ModelPage/></Suspense>}/>
                            </Route>

                            <Route path='model/presaged'
                                   element={<Suspense fallback={<>...</>}><ModelPage/></Suspense>}/>
                        </>}
                        
                        {(pageInfo?.feature_pipeline) &&
                            <Route path='pipelinestudio' element={<Suspense fallback={<>...</>}><ProvideTheme themeType={'dark'}><PipelineStudioPage /></ProvideTheme></Suspense>} />
                        }

                        <Route path='tools' element={<Suspense fallback={<>...</>}><ToolListPage/></Suspense>}/>
                        <Route path='registertool'
                               element={<Suspense fallback={<>...</>}><ToolRegisterPage/></Suspense>}/>
                        {(pageInfo?.tools_page) &&
                            <Route path='tool' element={<Suspense fallback={<>...</>}><ToolPage/></Suspense>}>
                                <Route path=':name'
                                       element={<Suspense fallback={<>...</>}><ToolPage/></Suspense>}/>
                            </Route>
                        }

                        {(pageInfo?.admin_page) &&
                            <Route path='admin' element={<Suspense fallback={<>...</>}><AdminPage /></Suspense>} />
                        }

                        <Route path='docs' element={<Suspense fallback={<>...</>}><DocumentsPage/></Suspense>}>
                            <Route path=':name' element={<Suspense fallback={<>...</>}><DocumentsPage/></Suspense>}/>
                        </Route>
                        <Route path='secure'
                               element={<Suspense fallback={<>...</>}><LoginPage key={Date.now()}/></Suspense>}/>
                        {/*<Route path='logout' element={<LogoutPage key={Date.now()} />} />*/}
                        <Route path="/health-rapids">
                            <Fragment>
                                 The UI is Healthy
                            </Fragment>
                        </Route>
                        <Route path='*' element={<Navigate replace to='home'/>}/>
                    </Routes>
                    <ChallengeFooter/>
                </Router>
            </div>
        </ProvideTheme>
    );
}

const mapStateToProps = (state) => {
    return {
        userInfo: state.userInfo,
        pageInfo: state.pageInfo,
        logged_in: state.userInfo.logged_in,
    }
}

export default connect(mapStateToProps)(Challenge);
